import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  className = '',
  delay = 0,
  y = 28,
  once = true,
  as = 'div',
  ...rest
}) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;

  if (reduce) {
    const StaticTag = as === 'div' ? 'div' : as;
    return <StaticTag className={className} {...rest}>{children}</StaticTag>;
  }

  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration: 0.65, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const staggerParent = (reduce) => (
  reduce
    ? {}
    : {
        initial: 'hidden',
        animate: 'show',
        variants: {
          hidden: {},
          show: { transition: { staggerChildren: 0.08, delayChildren: 0.12 } }
        }
      }
);

export const staggerItem = (reduce) => (
  reduce
    ? {}
    : {
        variants: {
          hidden: { opacity: 0, y: 22 },
          show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } }
        }
      }
);

export { EASE };
